export default "__VITE_ASSET__BiG2yfw9__"